import { FC } from 'react';

import { Header } from 'shared/containers/Header';
import { Promos } from 'shared/containers/Promos';
import { Projects } from 'shared/containers/Projects';
import { MortgageCalculator } from 'shared/packages/mortgage-calculator';
import { PurchaseContainer } from 'shared/containers/PurchaseContainer';
import { Standard } from 'shared/containers/Standard';
import { Commercial } from 'shared/containers/Commercial';
import { About } from 'shared/containers/About';
import { AdfoxPixelContainer } from 'shared/containers/AdfoxPixel';
import { Carousel } from 'shared/containers/Carousel';

import { RatingsContainer } from '../Ratings';
import { AwardsContainer } from '../Awards';
import { OfficesContainer } from '../Offices';
import { ContentWrapper } from '../ContentWrapper';
import { FactsContainer } from '../Facts';
import { SeriaPlusContainer } from '../SeriaPlus';
import { InvestmentBlockContainer } from '../InvestmentBlock';
import { PikInNumbers } from '../PikInNumbers';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { PikHistoryContainer } from '../PikHistory';

export const ApplicationContent: FC = () => {
  const { config } = useApplicationContext();

  /**
   * @todo Удалить фича тоггл
   * @description Данный функционал появился в задаче CD-240411, будет удалён в задаче CD-241279
   * Не забудь удалить из scheme.json
   */
  const pikLandingBlocksUpdateEnabled = config.get<boolean>('PikLanding.BlocksUpdate.Enabled');

  return (
    <div data-testid="ApplicationContent">
      <Carousel />
      <ContentWrapper>
        <Header />
        <FactsContainer />
        <Promos />
        <Projects />
        <SeriaPlusContainer />
        <MortgageCalculator />
        {
          /**
           * @todo Удалить фича тоггл
           * @description Данный функционал появился в задаче CD-240411, будет удалён в задаче CD-241279
           * Блок оставить
           */
          pikLandingBlocksUpdateEnabled && <PikInNumbers />
        }
        {
          /**
           * @todo Удалить фича тоггл
           * @description Данный функционал появился в задаче CD-240416, будет удалён в задаче CD-241279
           * Блок оставить
           */
          pikLandingBlocksUpdateEnabled && <PikHistoryContainer />
        }
        <InvestmentBlockContainer />
        <PurchaseContainer />
        <Standard />
        <Commercial />
        <RatingsContainer />
        <AwardsContainer />
        <OfficesContainer />
        <About />
        <AdfoxPixelContainer />
      </ContentWrapper>
    </div>
  );
};
